export default "__VITE_ASSET__BNhegJUU__"